// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._0e8435{color:var(--secondary) !important;font-size:.675em !important}svg+._0e8435{display:none}._0e8435 small{display:block;font-size:.8em;text-transform:lowercase}._7a783f:hover svg{display:none}._7a783f:hover ._0e8435{display:block}._465609{opacity:.25;border-color:rgba(0,0,0,0);pointer-events:none}.a9a454 svg{fill:var(--primary)}._807eb8 svg{fill:var(--alert)}._4fe139 svg{fill:var(--danger)}", ""]);
// Exports
exports.locals = {
	"caption": "_0e8435",
	"has-caption": "_7a783f",
	"hasCaption": "_7a783f",
	"disabled": "_465609",
	"completed": "a9a454",
	"skipped": "_807eb8",
	"missed": "_4fe139"
};
module.exports = exports;
